import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// web routing
const PageNotFound = Loadable(lazy(() => import('features/pageNotFound')));

// ==============================|| AUTH ROUTING ||============================== //

const PageNotFoundRoutes = {
    path: '/',
    children: [
        {
            name: 'page-not-found',
            path: '/*',
            element: <PageNotFound />
        }
    ]
};

export default PageNotFoundRoutes;
